import React from 'react'
import {
  Navbar,
  ExternalButtonLink,
  HeaderAvatar,
  spacer,
  color,
  gradientStart,
  gradientEnd
} from 'stylist'
import { withRouter, Route } from 'react-router-dom'
import { signInUri } from 'utils/unifiedLogin'
import CurrentUser from 'components/CurrentUser'
import AdminSubnav from 'components/AdminSubnav'
import styled from 'react-emotion'

const NavbarsContainer = styled.div`
  padding-top: ${spacer(2)};

  background: ${color('ink')};
  border-width: 0 0 5px 0;
  border-style: solid;
  border-image: linear-gradient(
      to right,
      ${gradientStart('green')},
      ${gradientEnd('green')}
    )
    5;
`

const MainHeader = ({ location: { pathname } }) => (
  <NavbarsContainer>
    <Navbar homeRoute="/" dark>
      <CurrentUser
        render={currentUser =>
          currentUser ? (
            <HeaderAvatar
              align="right"
              firstName={currentUser.firstName || '?'}
            >
              <HeaderAvatar.MenuItem to="/logout">
                Sign Out
              </HeaderAvatar.MenuItem>
            </HeaderAvatar>
          ) : (
            <ExternalButtonLink href={signInUri(pathname)} kind="ghost">
              Sign In
            </ExternalButtonLink>
          )
        }
      />
    </Navbar>
    <Route path="/admin" component={AdminSubnav} />
  </NavbarsContainer>
)

export default withRouter(MainHeader)



// WEBPACK FOOTER //
// ./src/components/MainHeader.js